import React from 'react'
import styled from 'styled-components'

const FormContainer = styled.div`
  form {
    label {
      width: 100%;
    }
    input {
      width: 100%;
      font-family: inherit;
      font-size: inherit;
      margin-bottom: 0.8rem;
      border: 0;
      outline: 0;
      background: transparent;
      border-bottom: 1px solid #373435;
    }
    textarea {
      resize: none;
      width: 100%;
      font-family: inherit;
      font-size: inherit;
      height: 180px;
      margin-bottom: 0.8rem;
      border: 0;
      outline: 0;
      background: transparent;
      border: 1px solid #373435;
    }
    button {
      position: relative;
      border: none;
      width: 100%;
      height: 3rem;
      font-size: 2rem;
      background: #af3738;
      color: #fff;
      text-align: center;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
      cursor: pointer;
      box-shadow: inset 0 -2px #611f1f;
      &:active {
        top: 1px;
        outline: none;
        box-shadow: none;
      }
    }
  }
`

const Contacto = () => (
  <div>
    <h1>Contactenos</h1>
    <FormContainer>
      <form
        name="contact"
        method="post"
        data-netlify="true"
        data-netlify-honeypot="botfield"
      >
        <input type="hidden" name="form-name" value="contact" />
        <label htmlFor="name">Su nombre</label>
        <input name="name" placeholder="Nombre" type="text" />
        <label htmlFor="email">Correo Eléctronico</label>
        <input name="email" placeholder="correo@empresa.com" type="email" />
        <label htmlFor="message">Mensaje</label>
        <textarea name="message" placeholder="Necesito ayuda con..." />
        <button>Enviar</button>
      </form>
    </FormContainer>
  </div>
)

export default Contacto



// WEBPACK FOOTER //
// ./src/pages/contacto.js